import {SectionInterface} from "../../../../../../store/types/store";
import {ItemI} from "../../../../../../shared";
import {splitNameIntoRows} from "../../../../utils/splitNameIntoRows";
import {ISectionLabelRow} from "../../../../types";

interface IGetSectionItems extends ISectionElement{
    parts: Array<ISectionElement>
}

interface ISectionElement {
    id: number,
    label: string,
    count: number,
    price: number,
    isBold: boolean
}

export const getSectionItemsNames = (section: SectionInterface, parts: ItemI[]): Array<ISectionLabelRow> => {
    const stacked: Array<IGetSectionItems> = []
    const allSectionElements: Array<ISectionLabelRow> = []

    stacked.push(...section.items.reduce((acc, currentValue, currentIndex, array) => (acc.filter(({id}: any) => id === currentValue.bitrixId).length === 0 ? [...acc, {
        id: currentValue.bitrixId,
        label: currentValue.name,
        count: array.filter(({bitrixId}: any) => bitrixId === currentValue.bitrixId).length,
        price: currentValue.price,
        parts: array
            .filter(({bitrixId}: any) => bitrixId === currentValue.bitrixId)
            .flatMap((item) => {
                return [...(item.brackets.left.isVisible ? item.brackets.left.elements : []),
                    ...(item.brackets.right.isVisible ? item.brackets.right.elements : []),
                    ...(() => {
                        return item.parts.filter((element) => {
                            return item.edges?.filter((el) => el.bitrixId === element.bitrixId) !== undefined;
                        });
                    })(),
                ]
            })
            .reduce((acc, currentValue, currentIndex, array) => (acc.filter(({id}: any) => id === currentValue.bitrixId).length === 0 ?
                [...acc, {
                    id: currentValue.bitrixId,
                    label: parts?.find((p) => p.BITRIX_OFFER_ID === currentValue.bitrixId)?.NAME || '',
                    price: parts?.find((p) => p.BITRIX_OFFER_ID === currentValue.bitrixId)?.PRICE || 0,
                    count: array.filter(({bitrixId}: any) => bitrixId === currentValue.bitrixId).length,
                }] : acc), [] as any)
    }] : acc), [] as any))

    stacked.forEach(sectionElement => {
        const names = splitNameIntoRows(sectionElement.label, 190, 12)
        names.forEach((name, index, arrNames) => {
            const isLastName = arrNames.length - 1 === index
            allSectionElements.push({itemLabel: name, itemsCount: isLastName ? sectionElement.count : 0, isBoldItemLabel: true})
        })
        sectionElement.parts.forEach(part => {
            const partNames = splitNameIntoRows(part.label, 190, 12)
            partNames.forEach((name, index, arrNames) => {
                const isLastName = arrNames.length - 1 === index
                allSectionElements.push({itemLabel: name, itemsCount: isLastName ? sectionElement.count : 0, isBoldItemLabel: false})
            })
        })
    })

    return allSectionElements
}
